import React, { useContext } from "react";
import { Container, Card, CardBody, Col } from "reactstrap";
import styles from "./InvoiceConfirmation.module.css";
import BrandedIcon from '../../components/BrandingWhiteLabel/BrandedIcon';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { SessionContext } from '../../../src/context/SessionContext';

export const ClaimRejected = (props) => {
    const history = useHistory();
    const accountName = typeof props.accountName == "undefined" || props.accountName == null ? '' : props.accountName;
    const claimNumber = typeof props.claimNumber == "undefined" || props.claimNumber == null ? '' : props.claimNumber;
    const ruleMessage = typeof props.ruleMessage == "undefined" || props.ruleMessage == null ? '' : props.ruleMessage;
    const { tabDispatch, getCurrentTabAndSubtab } = useContext(SessionContext)
    const { invoiceId } = getCurrentTabAndSubtab().subtab;

    const handleClaimClick = () => {
        history.push('/', {})
        tabDispatch('ADD_SUBTAB', {
            subtabType: 'staticclaiminvoice',
            invoiceId: invoiceId,
            claimNumber: claimNumber
        })
    };

    return (
        <Container className={"contentWrapper"}>
            <Card>
                <CardBody>
                    <div className={classNames(styles.thanksConfirmation, styles.reviewConfirmation )}>
                        <BrandedIcon accountName={accountName} iconType={'denied'} />
                    </div>
                    <Col md="10" lg="8" className={styles.invMessage}>
                        <h1 className="h3">Claim Denied</h1>
                        <p>
                            Unfortunately, this claim has been denied for the following reason:
                        </p>
                        <p>{ruleMessage}</p>
                        Claim Number: {claimNumber}
                        <div>
                            <a className={classNames(styles.redirectLink, "btnLink")} onClick={handleClaimClick}>
                                View Claim Details
                            </a>
                        </div>
                    </Col>
                </CardBody>
            </Card>
        </Container>
    );
}
